export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_FR_RGB_blk_100517.fa603df2.svg";